module.exports = __webpack_public_path__ + "static/media/green_normal_EN.7293b875.png";